/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Stage_Agent_ReadinessInputs */

const en_directory_submit_enrich_stage_agent_readiness = /** @type {(inputs: Directory_Submit_Enrich_Stage_Agent_ReadinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent readiness`)
};

const zh_directory_submit_enrich_stage_agent_readiness = /** @type {(inputs: Directory_Submit_Enrich_Stage_Agent_ReadinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 就绪评估`)
};

/**
* | output |
* | --- |
* | "Agent readiness" |
*
* @param {Directory_Submit_Enrich_Stage_Agent_ReadinessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_stage_agent_readiness = /** @type {((inputs?: Directory_Submit_Enrich_Stage_Agent_ReadinessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Stage_Agent_ReadinessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_stage_agent_readiness(inputs)
	return zh_directory_submit_enrich_stage_agent_readiness(inputs)
});
export { directory_submit_enrich_stage_agent_readiness as "directory.submit.enrich.stage.agent_readiness" }